// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Base Serializer for all Serializer implementations in Terminology.
 * @see #/components/schemas/MedicationCreateUpdateDeleteResponse - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MedicationCreateUpdateDeleteResponse {
    /**
     * medication create update status
     *
     */
    message: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MedicationCreateUpdateDeleteResponse
 */
export namespace MedicationCreateUpdateDeleteResponse {
    /**
     * MedicationCreateUpdateDeleteResponse Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * medication create update status
         * @type string (`dataFormat` is missing)
         */
        message: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MedicationCreateUpdateDeleteResponse DTO
     * Transforms MedicationCreateUpdateDeleteResponse model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MedicationCreateUpdateDeleteResponse model */
        static toModel(obj: MedicationCreateUpdateDeleteResponse): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MedicationCreateUpdateDeleteResponse model */
        static toApi(obj: Model): MedicationCreateUpdateDeleteResponse {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MedicationCreateUpdateDeleteResponse;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
